<template>
  <div id='app'>
    <Layout :class="bgClass" v-if="isRouterAlive">
      <Header ref="headers"></Header>
      <Content :style='{position: "relative",width:"1200px",margin:"0 auto",minHeight:Height+"px"}'>
          <router-view></router-view>
      </Content>
      <Footer></Footer>
    </Layout>
    <BackTop></BackTop>
  </div>
</template>

<script>
import Header from '@/components/layout/Header.vue'
import Footer from '@/components/layout/Footer.vue'
import BackTop from '@/components/backTop/Index.vue'
import Vue from "vue";
export default {
  name: 'App',
  // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      Height: 0,
      isRouterAlive: true,
      isHeaderAlive: true,
      bgClass: '',
      handleKey: 1
    }
  },
  components: {
    Header,
    Footer,
    BackTop
  },
  updated () {
    const path = this.$route.path
    if (path.indexOf('login') > -1) {
      this.bgClass = 'bg-img'
    } else {
      this.bgClass = ''
    }
    // this.handleKey = Math.random()*100
  },
  mounted () {
    if (this._isMobile()) {
      this.$router.replace('/mobile');
      document.getElementById("app").innerHTML = "<div style='text-align:center;margin-top:120px;width:100%'><img src='./img/YHY-QR.jpg' alt='' /><h4>请使用电脑，或使用微信扫码购票</h4></div>"
    } 
  // 动态设置内容高度 让footer始终居底   header+footer的高度是208
    this.Height = document.documentElement.clientHeight - 208
    window.onresize = () => { this.Height = document.documentElement.clientHeight - 208 }
    window.addEventListener('storage', this.reportParamsObjStorage, false)
  },
  destroyed () {
    window.removeEventListener('storage', this.reportParamsObjStorage)
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|BrowserN|Windows Phone)/i)
      return flag;
    },
    reload () {
      this.isRouterAlive = false // 先关闭,
      this.$nextTick(() => {
        this.isRouterAlive = true // 再打开
      })
    },
    reportParamsObjStorage (e) {
      if (e.key.indexOf('token') > -1) {
        this.reload()
        this.$router.push('/')
        this.$refs.headers.handleLoginStatus()
      }
    }
  }
}
</script>

<style>
html,
body {
  padding: 0px;
  margin: 0px;
  height: 100%;
}
body{
  overflow: unset!important;
}
#app {
  height: 100%;
  /* background-color: #f5f7f9; */
}
.bg-img{
  background: url("assets/bg-img.jpg") center center!important;
  background-size: cover!important;
}
</style>
